import {addIndex, map} from "ramda"

const mapIndexed = addIndex(map)

export default mapIndexed
